<template>
  <span v-if="subtitle" class="grid-y align-items-start" v-bind="$attrs">
    <span class="heavy-sm relative info-row-1"><slot></slot></span>
    <span class="small relative info-row-2" data-fs-mask>{{ subtitle }}</span>
  </span>
  <span v-else class="grid-x heavy-sm" v-bind="$attrs"><slot></slot></span>
</template>

<script setup>
defineProps({
  subtitle: {
    type: String,
    default: '',
  },
});
</script>

<style lang="scss" brand="mcom" scoped>
.info-row-1 {
  top: 1px;
}

.info-row-2 {
  top: -1px;
}
</style>
